export const tourActionConstants = {
  TOUR_SELECTED: 'TOUR_SELECTED',
  CLEAR_TOUR_SELECTED: 'CLEAR_TOUR_SELECTED',
  GET_TOUR_STATUS: 'GET_TOUR_STATUS',
};
